// src/pages/People/DetailInfoSkeleton.tsx
import React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Skeleton } from "@/components/ui/skeleton";

export default function DetailInfoSkeleton() {
    return (
        <div className="mx-auto w-full max-w-6xl px-4 py-6">
            {/* Header */}
            <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                <div className="space-y-2">
                    <Skeleton className="h-8 w-[280px] sm:w-[420px]" />
                    <Skeleton className="h-4 w-[220px] sm:w-[300px]" />
                </div>

                <div className="flex flex-wrap items-center gap-2">
                    <Skeleton className="h-10 w-28 rounded-md" />
                    <Skeleton className="h-10 w-40 rounded-md" />
                </div>
            </div>

            <Separator className="my-5" />

            <div className="space-y-4">
                {/* 1. Личная информация */}
                <Card>
                    <CardHeader className="pb-3">
                        <Skeleton className="h-4 w-44" />
                    </CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                            {Array.from({ length: 6 }).map((_, i) => (
                                <div key={i} className="space-y-2">
                                    <Skeleton className="h-3 w-24" />
                                    <Skeleton className="h-10 w-full" />
                                </div>
                            ))}
                        </div>
                    </CardContent>
                </Card>

                {/* 2. Информация о телефоне */}
                <Card>
                    <CardHeader className="pb-3">
                        <Skeleton className="h-4 w-56" />
                    </CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                            {Array.from({ length: 4 }).map((_, i) => (
                                <div key={i} className="space-y-2">
                                    <Skeleton className="h-3 w-24" />
                                    <Skeleton className="h-10 w-full" />
                                </div>
                            ))}
                        </div>
                    </CardContent>
                </Card>

                {/* 3. Кредит */}
                <Card>
                    <CardHeader className="pb-3">
                        <div className="flex items-center justify-between gap-3">
                            <Skeleton className="h-4 w-40" />
                            <Skeleton className="h-9 w-28 rounded-md" />
                        </div>
                    </CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
                            {Array.from({ length: 3 }).map((_, i) => (
                                <div key={i} className="rounded-xl border p-4 space-y-3">
                                    <Skeleton className="h-3 w-20" />
                                    <Skeleton className="h-6 w-24" />
                                    <Skeleton className="h-4 w-full" />
                                </div>
                            ))}
                        </div>

                        <div className="mt-4 space-y-2">
                            <Skeleton className="h-4 w-44" />
                            <Skeleton className="h-24 w-full rounded-xl" />
                        </div>

                        <div className="mt-4 space-y-2">
                            <Skeleton className="h-4 w-40" />
                            {Array.from({ length: 3 }).map((_, i) => (
                                <div key={i} className="flex items-center justify-between rounded-xl border p-3">
                                    <div className="space-y-2">
                                        <Skeleton className="h-4 w-44" />
                                        <Skeleton className="h-3 w-28" />
                                    </div>
                                    <Skeleton className="h-9 w-24 rounded-md" />
                                </div>
                            ))}
                        </div>
                    </CardContent>
                </Card>

                {/* 4. Комментарии */}
                <Card>
                    <CardHeader className="pb-3">
                        <div className="flex items-center justify-between gap-3">
                            <Skeleton className="h-4 w-32" />
                            <Skeleton className="h-9 w-28 rounded-md" />
                        </div>
                    </CardHeader>
                    <CardContent>
                        <div className="space-y-3">
                            {Array.from({ length: 3 }).map((_, i) => (
                                <div key={i} className="rounded-xl border p-3 space-y-2">
                                    <div className="flex items-center justify-between gap-3">
                                        <Skeleton className="h-4 w-40" />
                                        <Skeleton className="h-3 w-20" />
                                    </div>
                                    <Skeleton className="h-4 w-full" />
                                    <Skeleton className="h-4 w-[85%]" />
                                </div>
                            ))}
                        </div>

                        <div className="mt-4 space-y-2">
                            <Skeleton className="h-10 w-full" />
                            <div className="flex justify-end">
                                <Skeleton className="h-10 w-32 rounded-md" />
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
